import SearchIcon from 'src/common/components/shared/svgIcons/SearchIcon';
import {
  AUDIOBOOKS_BROWSE_PATH,
  HOME_BROWSE_PATH,
  MUSIC_BROWSE_PATH,
  NEWS_BROWSE_PATH,
  PODCASTS_BROWSE_PATH,
  SEARCH_PATH,
  SPORTS_BROWSE_PATH,
} from 'src/common/constants/paths';
import {
  AUDIOBOOKS,
  FOR_YOU,
  MUSIC_UPPERCASE,
  NEWS_UPPERCASE,
  PODCASTS_UPPERCASE,
  SPORTS_UPPERCASE,
} from 'src/common/constants/localizations/shared';
import cssVars from 'src/common/styles/variables';

export const browsiesByPath = {
  [SEARCH_PATH]: {
    label: ({ isSelected }) => (
      <SearchIcon
        id="browsiesSearchIcon"
        dataTestId="browsiesSearchIcon"
        fill={
          cssVars[isSelected ? '--secondary-color-5' : '--anti-flash-white']
        }
        height="21px"
        width="21px"
      />
    ),
    href: SEARCH_PATH,
  },
  [HOME_BROWSE_PATH]: {
    label: FOR_YOU,
    href: HOME_BROWSE_PATH,
  },
  [MUSIC_BROWSE_PATH]: {
    label: MUSIC_UPPERCASE,
    href: MUSIC_BROWSE_PATH,
  },
  [SPORTS_BROWSE_PATH]: {
    label: SPORTS_UPPERCASE,
    href: SPORTS_BROWSE_PATH,
  },
  [NEWS_BROWSE_PATH]: {
    label: NEWS_UPPERCASE,
    href: NEWS_BROWSE_PATH,
  },
  [PODCASTS_BROWSE_PATH]: {
    label: PODCASTS_UPPERCASE,
    href: PODCASTS_BROWSE_PATH,
  },
  [AUDIOBOOKS_BROWSE_PATH]: {
    label: AUDIOBOOKS,
    href: AUDIOBOOKS_BROWSE_PATH,
  },
};

export const browsies = Object.values(browsiesByPath);
